import { ALL_ICONS, DEPT_OPTIONS, getActionDisplay } from '../featureFormConstants';
import type { ActionCatalogEntry } from '../featureFormConstants';
import type { FeatureDepartment } from '../../../../types/feature';

export function LivePreview({ name, icon, route, dept, module: mod, scopeActions, parentName, actionCatalog }:
  { name: string; icon: string; route: string; dept: FeatureDepartment; module: string; scopeActions: string[]; parentName?: string; actionCatalog: ActionCatalogEntry[] }) {
  const IconComp = ALL_ICONS.find(i => i.key === icon)?.Component;
  const deptOpt = DEPT_OPTIONS.find(d => d.value === dept);

  return (
    <div className="bg-white rounded-xl border-2 border-gray-200 overflow-hidden">
      {/* Header */}
      <div className="bg-gray-800 px-4 py-2.5 flex items-center gap-2">
        <div className="flex gap-1">
          <span className="w-2.5 h-2.5 rounded-full bg-red-400" />
          <span className="w-2.5 h-2.5 rounded-full bg-yellow-400" />
          <span className="w-2.5 h-2.5 rounded-full bg-green-400" />
        </div>
        <span className="text-xs text-gray-400 ml-1">Sidebar Preview</span>
      </div>

      {/* Sidebar simulation */}
      <div className="p-3 bg-gray-50 min-h-[120px]">
        {parentName && (
          <div className="flex items-center gap-2 px-3 py-2 mb-1 rounded-lg text-gray-500 text-xs">
            <span className="opacity-50">▸</span>
            <span className="font-medium">{parentName}</span>
          </div>
        )}
        <div className={`flex items-center gap-2.5 px-3 py-2.5 rounded-xl transition-colors ${
          name ? 'bg-emerald-600 text-white shadow-md' : 'bg-gray-200 text-gray-400'
        }`}>
          {IconComp ? (
            <IconComp className="w-4 h-4 flex-shrink-0" />
          ) : (
            <span className="w-4 h-4 rounded bg-white/30" />
          )}
          <span className="text-sm font-medium truncate">{name || 'Feature Name'}</span>
          {route && route !== '#' && (
            <span className="ml-auto text-xs opacity-70 truncate max-w-[80px]">{route}</span>
          )}
        </div>

        {/* Dept badge */}
        {deptOpt && (
          <div className="mt-2 flex items-center gap-1.5">
            <span className={`text-xs px-2 py-0.5 rounded-full font-semibold border ${deptOpt.color}`}>
              {deptOpt.icon} {deptOpt.shortLabel}
            </span>
          </div>
        )}
      </div>

      {/* Permission summary */}
      <div className="border-t border-gray-200 px-3 py-2 bg-white">
        <p className="text-xs font-semibold text-gray-500 mb-1">Role permissions for <code className="text-purple-600">{mod || '?'}</code>:</p>
        <div className="flex flex-wrap gap-1">
          {scopeActions.length > 0 ? scopeActions.map(a => {
            const display = getActionDisplay(a);
            return (
              <span key={a} className="text-xs px-1.5 py-0.5 rounded bg-gray-100 text-gray-600 font-mono">
                {display.emoji} {a}
              </span>
            );
          }) : (
            <span className="text-xs text-gray-300">No permissions defined</span>
          )}
        </div>
      </div>
    </div>
  );
}
